<template>
<!-- eslint-disable max-len -->
<span>
  <top-bar v-if="narrative.showNavbar" show-player>
    <template :slot="narrative.showMetrics ? 'challenge' : 'default'">
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks
        This is what the following line used to be:
        {{ narrativeNavbarText }}
      -->
      <p v-html="narrativeNavbarText"></p>
    </template>
    <cash-navbar v-if="narrative.showMetrics" slot="cash"></cash-navbar>
    <metrics-navbar v-if="narrative.showMetrics" slot="metrics"></metrics-navbar>
  </top-bar>

  <transition :enter-active-class="leftCharacterAnimateEnter ? 'animated slideInLeft' : ''" :leave-active-class="leftCharacterAnimateLeave ? 'animated slideOutLeft' : ''">
    <player v-if="showPlayer" :full="!narrative.showNavbar"></player>
  </transition>

  <transition enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
    <div v-if="showCharacters" class="other-players" :class="{ full: !narrative.showNavbar }">
      <div v-for="({ character }, i) in otherPlayers" :key="`player-${i}`" class="other-player" :style="{ left: `${315 + 300 * i}px` }">
          <img :src="resolveAssetPath(character.image, 'characters')" key="absent">
      </div>
    </div>
  </transition>

  <bottom-bar
    :next="((showButton && !center) ? onComplete : undefined)"
    :back="((enableBack && !center) ? (() => onComplete(true)) : undefined)"
  >
    <span slot="button">
      <span v-html="(narrative && narrative.nextButtonText) ? narrative.nextButtonText : ((game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next')"></span>
    </span>
    <span slot="back">
      <span v-html="(narrative && narrative.backButtonText) ? narrative.backButtonText : ((game && game.backButtonDefaultText) ? game.backButtonDefaultText : 'Back')"></span>
    </span>
  </bottom-bar>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <narrator-panel
      v-if="showSpeakerBubble && center"
      class="narrator-panel"
      :next="onComplete"
      :back="(enableBack ? (() => onComplete(true)) : undefined)"
      :character="narrative.centerNarrator ? narrator : characters[narrative.centerCharacter]"
      :player="narrative.centerPlayer"
    >
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks,
        but this is okay here since narrativeText is only used/set internally.
        AFAIK, this is the simplest way to support hyperlinks in dialogue, and it also enables any html formatting.
        This is what the following line used to be:
        <paragraphs>{{ narrativeText }}</paragraphs>
      -->
      <p v-html="narrativeText"></p>
    </narrator-panel>
  </transition>
</span>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

import Paragraphs from '../../ui/display/Paragraphs';
import TopBar from '../ui/TopBar';
import MetricsNavbar from '../ui/MetricsNavbar';
import CashNavbar from '../ui/CashNavbar';
import Player from '../ui/Player';
import BottomBar from '../ui/BottomBar';
import NarratorPanel from '../ui/NarratorPanel';

export default {
  // $emit 'input' on complete
  components: {
    Paragraphs,
    TopBar,
    MetricsNavbar,
    CashNavbar,
    Player,
    BottomBar,
    NarratorPanel
  },
  data() {
    return {
      showPlayer: false,
      showCharacters: false,
      showButton: false,
      showSpeakerBubble: false
    };
  },
  computed: {
    ...mapGetters([
      'characters',
      'tooltip',
      'otherPlayers',
      'narrative',
      'narrator',
      'game',
      'stopSounds',
      'lastNarrative',
      'nextNarrative',
      'narrativeNavbarText',
      'narrativeText',
      'leftCharacterAnimateEnter',
      'leftCharacterAnimateLeave'
    ]),
    center() {
      return this.narrative && this.narrative.speaker === 'center';
    },
    enableBack() {
      return this.showButton && (this.narrative.forceEnableBack || (this.game.enableBack && !(this.narrative.preventEnableBack)));
    },
  },
  methods: {
    async show() {
      this.showPlayer = true;
      this.showCharacters = true;
      await Vue.nextTick();
      this.stopSounds();
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.showSpeakerBubble = true;
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.showButton = true;
    },
    async hide() {
      this.showSpeakerBubble = false;
      this.showButton = false;
      this.showCharacters = false;
      this.showPlayer = !this.leftCharacterAnimateLeave;
      await Vue.nextTick();
      this.stopSounds();
    },
    async reset() {
      this.showSpeakerBubble = false;
      this.showButton = false;
      await Vue.nextTick();
      this.stopSounds();
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.showSpeakerBubble = true;
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.showButton = true;
    },
    async onComplete(back = false) {
      if (this.tooltip && this.tooltip.preventStateProgressionWhileOpen) {
        window.dispatchEvent(new Event('click'));
        return;
      }
      if (!this.nextNarrative) await this.hide();
      this.$emit('input', back);
    }
  },
  watch: {
    async narrative(newValue) {
      if (newValue) await this.reset();
    }
  },
  created() {
    this.showPlayer = !this.leftCharacterAnimateEnter;
  },
  async mounted() {
    await this.show();
  },
  async beforeDestroy() {
    await this.hide();
  }
};
</script>

<style lang="scss" scoped>
.other-players {
  bottom: -115px;
  width: 100%;
  height: 100%;
  position: absolute;
}
.other-players.full {
  bottom: 0;
}
.other-player {
  position: absolute;
  transform: scale(0.85);
}
.other-player img {
  transform: scaleX(-1);
}
.narrator-panel {
  left: 30px;
  bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/narrative/NarrativeTeam.vue